
import React from 'react';
import PropTypes from 'prop-types';

import SVGIcon from './SVGIcon.jsx';

const Icon = ({ type }) => {
    let path;
    let style;
    let viewBox;
    switch (type) {
    case 'person':
        path = 'M14.757 11.376a6.014 6.014 0 0 0 3.283-5.357A6.02 6.02 0 0 0 6 6.02a6.014 6.014 0 0 0 3.269 5.35C4.46 12.586-.003 16.676 0 20.072.001 21.634 6.803 24 12 24c5.226 0 12-2.343 12-3.929 0-3.389-4.447-7.47-9.243-8.695zM7 6.019a5.02 5.02 0 0 1 10.04 0c0 2.69-2.12 4.866-4.778 4.995-.087-.002-.175-.014-.262-.014-.078 0-.157.01-.236.013C9.113 10.877 7 8.703 7 6.019zm15.904 14.087a3.8 3.8 0 0 1-.642.444c-.623.36-1.504.746-2.52 1.097C17.332 22.482 14.557 23 12 23c-2.55 0-5.321-.523-7.742-1.365-1.013-.352-1.895-.74-2.52-1.1-.468-.269-.738-.513-.738-.464-.003-3.35 5.55-7.847 10.642-8.052.126.008.25.02.378.02.12 0 .238-.012.357-.019 5.085.216 10.624 4.705 10.623 8.051 0-.066-.02-.035-.096.035z';
        style = {
            display: 'block',
            fill: 'currentcolor',
            height: '26px',
            width: '26px'
        };
        viewBox = '0 0 24 24';
        return (
            <SVGIcon
                path={path}
                style={style}
                viewBox={viewBox}
            />
        );
    case 'suitcase':
        path = 'M21.5 5H16V3.499C16 2.667 15.328 2 14.497 2H9.503C8.665 2 8 2.668 8 3.499V5H2.5A2.501 2.501 0 0 0 0 7.494v12.012A2.499 2.499 0 0 0 2.5 22h19a2.5 2.5 0 0 0 2.5-2.494V7.494A2.499 2.499 0 0 0 21.5 5zM3 10v11h-.5c-.828 0-1.5-.67-1.5-1.494V7.494C1 6.672 1.675 6 2.5 6H3v4zm2 11H4V6h1v15zM9 3.499c0-.28.218-.499.503-.499h4.994c.28 0 .503.221.503.499V5H9V3.499zM18 21H6V6h12v15zm2 0h-1V6h1v15zm3-1.494c0 .822-.675 1.494-1.5 1.494H21V6h.5c.828 0 1.5.67 1.5 1.494v12.012z';
        style = {
            display: 'block',
            fill: 'currentcolor',
            height: '26px',
            width: '26px'
        };
        viewBox = '0 0 24 24';
        return (
            <SVGIcon
                path={path}
                style={style}
                viewBox={viewBox}
            />
        );
    case 'speech-bubble':
        path = 'M1.631 12.72V5.884c0-2.206 1.775-3.994 3.966-3.994h12.806c2.192 0 3.966 1.785 3.966 3.994v6.836c0 2.208-1.77 3.994-3.96 3.994h-4.335v3.464c-.461-.42-.919-.84-1.349-1.237l-.027-.025c-1.17-1.076-1.965-1.815-2.184-2.035l-.165-.167H5.595c-2.191 0-3.964-1.785-3.964-3.994zm8.255 5.134c.349.335 1.058.992 2.05 1.905l.027.025c.502.462 1.04.955 1.58 1.448l.52.476.197.18.945.862v-4.895h3.203c2.816 0 5.092-2.298 5.092-5.135V5.884C23.5 3.045 21.22.75 18.403.75H5.597C2.782.75.5 3.048.5 5.884v6.836c0 2.84 2.28 5.134 5.095 5.134h4.291z';
        style = {
            display: 'block',
            fill: 'currentcolor',
            height: '26px',
            width: '26px'
        };
        viewBox = '0 0 24 24';
        return (
            <SVGIcon
                path={path}
                style={style}
                viewBox={viewBox}
            />
        );
    case 'heart':
        path = 'M23.993 2.75c-.296 0-.597.017-.898.051-1.14.131-2.288.513-3.408 1.136-1.23.682-2.41 1.621-3.688 2.936-1.28-1.316-2.458-2.254-3.687-2.937-1.12-.622-2.268-1.004-3.41-1.135a7.955 7.955 0 0 0-.896-.051C6.123 2.75.75 4.289.75 11.128c0 7.862 12.238 16.334 14.693 17.952a1.004 1.004 0 0 0 1.113 0c2.454-1.618 14.693-10.09 14.693-17.952 0-6.84-5.374-8.378-7.256-8.378';
        style = {
            height: '26px',
            width: '26px',
            display: 'block'
        };
        viewBox = '0 0 32 32';
        return (
            <SVGIcon
                path={path}
                style={style}
                viewBox={viewBox}
                fill="currentColor"
                fillOpacity="0"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        );
    case 'search':
        path = 'M10.4 18.2c-4.2-.6-7.2-4.5-6.6-8.8.6-4.2 4.5-7.2 8.8-6.6 4.2.6 7.2 4.5 6.6 8.8-.6 4.2-4.6 7.2-8.8 6.6M23 22l-5-5c1.4-1.4 2.3-3.1 2.6-5.2.7-5.1-2.8-9.7-7.8-10.5-5-.7-9.7 2.8-10.5 7.9-.7 5.1 2.8 9.7 7.8 10.5 2.5.4 4.9-.3 6.7-1.7v.1l5 5c.3.3.8.3 1.1 0 .3-.3.4-.8.1-1.1';
        style = {
            display: 'block',
            fill: 'currentcolor',
            height: '18px',
            width: '18px'
        };
        viewBox = '0 0 24 24';
        return (
            <SVGIcon
                path={path}
                style={style}
                viewBox={viewBox}
            />
        );
    case 'cross':
        path = 'M1.705 13.705A1 1 0 1 1 .29 12.29l8-7.995a1 1 0 0 1 1.414 0l8 7.995a1 1 0 1 1-1.414 1.415l-7.293-7.29-7.293 7.29z';
        style = {
            display: 'block',
            fill: 'rgb(72, 72, 72)',
            height: '16px',
            width: '16px'
        };
        viewBox = '0 0 18 18';
        return (
            <SVGIcon
                path={path}
                style={style}
                viewBox={viewBox}
            />
        );
    case 'location-pin':
        return (
            <svg
                viewBox="0 0 24 24"
                role="presentation"
                aria-hidden="true"
                focusable="false"
                style={{
                    display: 'block',
                    fill: 'currentcolor',
                    height: '1em',
                    width: '1em'
                }}
            >
                <g fillRule="evenodd">
                    <path d="M12 23.75c2.973 0 9.75-8.262 9.75-13.75A9.723 9.723 0 0 0 11.999.25 9.732 9.732 0 0 0 2.25 10c0 3.107 1.571 6.411 4.1 9.41 2.051 2.435 4.499 4.34 5.65 4.34zM3.75 10a8.232 8.232 0 0 1 8.251-8.25A8.223 8.223 0 0 1 20.25 10c0 2.546-1.414 5.536-3.696 8.318C14.76 20.505 12.586 22.25 12 22.25c-.542 0-2.734-1.707-4.504-3.806C5.175 15.69 3.75 12.693 3.75 10z" />
                    <path d="M12 5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9zm0 7.5a3 3 0 1 1 0-6 3 3 0 0 1 0 6z" />
                </g>
            </svg>
        );
    case 'calendar':
        path = 'M22 9.5V3h-4.75V1a.75.75 0 1 0-1.5 0v2H8.249l.001-2a.75.75 0 1 0-1.5 0l-.001 2H2v19.008a1 1 0 0 0 .992.992h18.016a1 1 0 0 0 .992-.992V9.5zm-18.5-5h3.248V5a.75.75 0 0 0 1.5 0v-.5h7.502V5a.75.75 0 0 0 1.5 0v-.5h3.25V8h-17V4.5zm0 17v-12h17v12h-17z';
        style = {
            display: 'block',
            fill: 'currentcolor',
            height: '1em',
            width: '1em'
        };
        viewBox = '0 0 24 24';
        return (
            <SVGIcon
                path={path}
                style={style}
                viewBox={viewBox}
            />
        );
    case 'people':
        path = 'M3.31 11.565c-.657.503-1.101.992-1.47 1.664-1.141 2.08-1.464 6.818-.199 8.523 1.302 1.755 2.688 2.154 6.542 2.154 2.814 0 4.703-1.003 5.166-3.427.16-.839.139-1.547-.013-2.588l-.055-.367c-.122-.797-.163-1.179-.16-1.662.01-1.547.733-2.278 2.623-3.239.555-.283.903-.854.901-1.476-.001-.468-.2-.842-.538-1.209a3.055 3.055 0 0 1-.48-.69c-.315-.618-.397-1.19-.388-1.977v-.123c0-1.648.812-2.646 2.161-2.646 1.35 0 2.16.998 2.16 2.646 0 1.037-.233 1.974-.987 2.79-.34.368-.538.74-.54 1.209a1.65 1.65 0 0 0 .904 1.476c1.869.952 2.601 1.693 2.634 3.25.009.405.022.767.049 1.366.109 2.45.06 3.222-.338 3.904-.474.809-1.603 1.24-3.89 1.263-1.194.012-1.64-.018-2.362-.184a.75.75 0 1 0-.335 1.462c.86.198 1.41.235 2.713.222 2.758-.028 4.371-.643 5.168-2.006.611-1.043.666-1.932.543-4.727-.027-.589-.04-.941-.048-1.331-.048-2.273-1.14-3.377-3.454-4.556a.15.15 0 0 1-.083-.135c0-.016.032-.077.141-.196.61-.66.996-1.43 1.204-2.265.14-.558.182-1.028.182-1.542 0-2.416-1.407-4.146-3.661-4.146s-3.66 1.73-3.66 4.146l-.001.108c-.01 1.01.1 1.788.55 2.673.188.368.425.712.716 1.027.108.117.14.178.14.196a.15.15 0 0 1-.082.134c-2.343 1.192-3.429 2.289-3.442 4.567-.003.585.044 1.026.177 1.897l.054.357c.13.89.146 1.448.023 2.09-.298 1.564-1.513 2.21-3.692 2.21-3.422 0-4.397-.282-5.337-1.549-.86-1.159-.578-5.29.309-6.907.26-.475.566-.811 1.067-1.195.291-.223 1.9-1.297 2.423-1.673.446-.321.71-.839.709-1.388l-.001-.15a1.755 1.755 0 0 0-.649-1.34C6.01 7.628 5.537 6.17 5.537 4.721c0-1.928 1.107-3.13 2.646-3.13s2.646 1.202 2.646 3.13c0 1.465-.458 2.913-1.144 3.481-.415.344-.65.836-.65 1.404a1.698 1.698 0 0 0 .922 1.519c.408.208.57.29.791.407a.75.75 0 1 0 .7-1.327c-.23-.12-.396-.206-.808-.416a.198.198 0 0 1-.106-.177c0-.123.034-.193.108-.254 1.1-.911 1.687-2.77 1.687-4.637 0-2.73-1.75-4.63-4.146-4.63s-4.146 1.9-4.146 4.63c0 1.85.606 3.724 1.71 4.637.07.059.106.13.106.193v.15a.204.204 0 0 1-.084.163c-.487.35-2.12 1.441-2.459 1.7z';
        style = {
            display: 'block',
            fill: 'currentcolor',
            height: '1em',
            width: '1em'
        };
        viewBox = '0 0 24 24';
        return (
            <SVGIcon
                path={path}
                style={style}
                viewBox={viewBox}
            />
        );
    }
};

Icon.propTypes = {
    type: PropTypes.string.isRequired
};

export default Icon;



// WEBPACK FOOTER //
// ./src/components/SVGIcon/index.js